const styles = (theme) => ({
  empty: {
    fontSize: 16,
    padding: theme.spacing(3, 0),
    color: theme.color.red_00,
  },
  scrollAreaWrapperWithTopSpace: {
    overflowX: 'hidden',
    height: 'calc(100% - 108px)',
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(0, 0, 0, 2.5),
    '&::-webkit-scrollbar': {
      width: 0,
      background: 'transparent',
    },
  },
  title: {
    width: '100%',
    alignItems: 'center',
    color: theme.color.grey_dark,
    flexWrap: 'nowrap',
    textTransform: 'uppercase',
    padding: theme.spacing(2.5, 0, 0, 2.5),
    '& div': {
      display: 'inline',
    },
  },
  scrollAreaWrapper: {
    overflowX: 'hidden',
    height: 'calc(100% - 60px)',
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(0, 0, 0, 2.5),
    '&::-webkit-scrollbar': {
      width: 0,
      background: 'transparent',
    },
  },
  scrollAreaWithRecentSearches: {
    height: 'calc(100% - 100px)',
  },
  listWrapper: {
    width: '95%',
  },
  listWrapperNoAlphabet: {
    width: '100%',
  },
  virtualizedListNoAlphabet: {
    '&:focus': {
      outline: 'none',
    },
  },
  virtualizedList: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  alphabetPlaceholder: {
    minWidth: 10,
  },
  loader: {
    display: 'block',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  createProfile: {
    margin: theme.spacing(2),
  },
});

export default styles;
